import React, { useEffect, useState } from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'
import AutoSuggestionInputCrew from './castandcrew'
function CrewAccordianData(props) {
  const {
    handleListData,
    listData,
    crewconditionOrAnd,
    dynamicListInfo,
    setListData,
    setDisableUpdateButton,
  } = props
  const [crewDirector, setCrewDirector] = useState([])
  const [crewProducer, setCrewProducer] = useState([])
  const [crewEditor, setCrewEditor] = useState([])
  const [crewMusicBy, setCrewMusicBy] = useState([])
  const [crewcinematography, setCrewcinematography] = useState([])
  const [crewwrittenBy, setCrewwrittenBy] = useState([])
  const [crewstoryBy, setCrewstoryBy] = useState([])
  const [crewDialog, setCrewDialog] = useState([])
  const [crewscreenplayBy, setCrewscreenplayBy] = useState([])

  useEffect(() => {
    if (
      crewDirector.length === 0 &&
      crewProducer.length === 0 &&
      crewEditor.length === 0 &&
      crewMusicBy.length === 0 &&
      crewcinematography.length === 0 &&
      crewwrittenBy.length === 0 &&
      crewstoryBy.length === 0 &&
      crewDialog.length === 0 &&
      crewscreenplayBy.length === 0
    ) {
      delete dynamicListInfo.crewFilterBy
    }
  }, [
    crewDirector,
    crewProducer,
    crewEditor,
    crewMusicBy,
    crewcinematography,
    crewwrittenBy,
    crewstoryBy,
    crewDialog,
    crewscreenplayBy,
  ])

  return (
    <Accordion allowZeroExpanded>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>Crew</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <select onChange={e => handleListData('crewFilterBy', e.target.value)}>
            <option></option>
            <option selected={listData.crewFilterBy === 'AND'} value='AND'>
              AND
            </option>
            <option selected={listData.crewFilterBy === 'OR'} value='OR'>
              OR
            </option>
          </select>
          <label>Director:</label>
          <AutoSuggestionInputCrew
            setCrewSelectedArryTocheckAndOrConditon={setCrewDirector}
            // setCrewOrcastData={props.setCrewOrcastData}
            setDisableUpdateButton={setDisableUpdateButton}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'directedBy_En'}
            listData={listData}
            setListData={setListData}
          />
          <label>Producer:</label>
          <AutoSuggestionInputCrew
            setDisableUpdateButton={setDisableUpdateButton}
            setCrewSelectedArryTocheckAndOrConditon={setCrewProducer}
            // setCrewOrcastData={props.setCrewOrcastData}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'producedBy_En'}
            listData={listData}
            setListData={setListData}
          />
          <label>Cinematographer:</label>
          <AutoSuggestionInputCrew
            setDisableUpdateButton={setDisableUpdateButton}
            setCrewSelectedArryTocheckAndOrConditon={setCrewcinematography}
            // // setCrewOrcastData={props.setCrewOrcastData}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'cinematography_En'}
            listData={listData}
            setListData={setListData}
          />
          <label>storyBy:</label>
          <AutoSuggestionInputCrew
            setDisableUpdateButton={setDisableUpdateButton}
            setCrewSelectedArryTocheckAndOrConditon={setCrewstoryBy}
            // // setCrewOrcastData={props.setCrewOrcastData}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'storyBy_En'}
            listData={listData}
            setListData={setListData}
          />
          <label>writer:</label>
          <AutoSuggestionInputCrew
            setDisableUpdateButton={setDisableUpdateButton}
            setCrewSelectedArryTocheckAndOrConditon={setCrewwrittenBy}
            // // setCrewOrcastData={props.setCrewOrcastData}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'writtenBy_En'}
            listData={listData}
            setListData={setListData}
          />
          <label>musician:</label>
          <AutoSuggestionInputCrew
            setDisableUpdateButton={setDisableUpdateButton}
            setCrewSelectedArryTocheckAndOrConditon={setCrewMusicBy}
            // // setCrewOrcastData={props.setCrewOrcastData}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'musicBy_En'}
            listData={listData}
            setListData={setListData}
          />
          <label>Dialogue writer:</label>
          <AutoSuggestionInputCrew
            setDisableUpdateButton={setDisableUpdateButton}
            setCrewSelectedArryTocheckAndOrConditon={setCrewDialog}
            // // setCrewOrcastData={props.setCrewOrcastData}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'dialogueBy_En'}
            listData={listData}
            setListData={setListData}
          />
          <label>Editor:</label>
          <AutoSuggestionInputCrew
            setDisableUpdateButton={setDisableUpdateButton}
            setCrewSelectedArryTocheckAndOrConditon={setCrewEditor}
            // // setCrewOrcastData={props.setCrewOrcastData}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'editedBy_En'}
            listData={listData}
            setListData={setListData}
          />
          <label>ScreenPlay:</label>
          <AutoSuggestionInputCrew
            setDisableUpdateButton={setDisableUpdateButton}
            setCrewSelectedArryTocheckAndOrConditon={setCrewscreenplayBy}
            // // setCrewOrcastData={props.setCrewOrcastData}
            conditionOrAnd={crewconditionOrAnd}
            dynamicListInfo={dynamicListInfo}
            typeValue={'screenplayBy_En'}
            listData={listData}
            setListData={setListData}
          />
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default CrewAccordianData
